import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';
import { SelectCannedResponseProps } from './SelectCannedResponse';

export async function openCannedResponseModal(props: Omit<SelectCannedResponseProps, 'onSelect'>) {
  const { SelectCannedResponse } = await import('./SelectCannedResponse');
  const obs$ = new Subject<string>();
  openModal(SelectCannedResponse, {
    ...props,
    onSelect: text => {
      obs$.next(text);
      obs$.complete();
    },
  });
  return obs$.asObservable();
}
